module.exports = __webpack_public_path__ + "img/autospin_btn.401ce69b.png";